import {
  ERROR_ASSIGN_HIGHLIGHT_RESOURCE,
  ERROR_ASSIGN_TAG_RESOURCE,
  ERROR_DELETE_RESOURCE,
  ERROR_DELETE_TAG_RESOURCE,
  ERROR_FILTER_RESOURCES,
  ERROR_GET_HOME_RESOURCES,
  ERROR_GET_RESOURCES,
  ERROR_MASS_ASSIGNMENT_RESOURCES,
  ERROR_SHOW_RESOURCE,
  ERROR_STORE_RESOURCE,
  ERROR_UPDATE_ALIAS_RESOURCE,
  ERROR_UPDATE_RESOURCE,
  ERROR_VIEW_RESOURCE,
  IResourceState,
  START_CLEAR_RESOURCES,
  START_ASSIGN_HIGHLIGHT_RESOURCE,
  START_ASSIGN_TAG_RESOURCE,
  START_DELETE_RESOURCE,
  START_DELETE_TAG_RESOURCE,
  START_FILTER_RESOURCES,
  START_GET_HOME_RESOURCES,
  START_GET_RESOURCES,
  START_MASS_ASSIGNMENT_RESOURCES,
  START_SHOW_RESOURCE,
  START_STORE_RESOURCE,
  START_SET_RESOURCE_PAGE,
  START_UPDATE_ALIAS_RESOURCE,
  START_UPDATE_RESOURCE,
  START_VIEW_RESOURCE,
  SUCCESS_ASSIGN_HIGHLIGHT_RESOURCE,
  SUCCESS_ASSIGN_TAG_RESOURCE,
  SUCCESS_DELETE_RESOURCE,
  SUCCESS_DELETE_TAG_RESOURCE,
  SUCCESS_FILTER_RESOURCES,
  SUCCESS_GET_HOME_RESOURCES,
  SUCCESS_GET_RESOURCES,
  SUCCESS_MASS_ASSIGNMENT_RESOURCES,
  SUCCESS_SHOW_RESOURCE,
  SUCCESS_STORE_RESOURCE,
  SUCCESS_TOGGLE_FORM_CREATE_RESOURCES,
  SUCCESS_TOGGLE_FORM_EDIT_RESOURCES,
  SUCCESS_TOGGLE_FORM_VIEW_RESOURCES,
  SUCCESS_UPDATE_ALIAS_RESOURCE,
  SUCCESS_UPDATE_RESOURCE,
  SUCCESS_VIEW_RESOURCE,
} from "../types";

const initialState: IResourceState = {
  reload: false,
  resources: [],
  feedResources: [],
  resourceSelected: null,
  msg: null,
  error: false,
  loading: false,
  showEditForm: false,
  showCreateForm: false,
  showViewForm: false,
  aliasUpdated: false,
  page: 1,
  hasMore: true,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_GET_RESOURCES:
    case START_SHOW_RESOURCE:
    case START_STORE_RESOURCE:
    case START_UPDATE_RESOURCE:
    case START_DELETE_RESOURCE:
    case START_VIEW_RESOURCE:
    case START_ASSIGN_TAG_RESOURCE:
    case START_DELETE_TAG_RESOURCE:
    case START_ASSIGN_HIGHLIGHT_RESOURCE:
    case START_FILTER_RESOURCES:
    case START_GET_HOME_RESOURCES:
    case START_MASS_ASSIGNMENT_RESOURCES:
      return {
        ...state,
        msg: null,
        error: false,
        loading: true,
      };
    case START_UPDATE_ALIAS_RESOURCE:
      return {
        ...state,
        msg: null,
        error: false,
        loading: true,
        aliasUpdated: false,
      };
    case SUCCESS_GET_RESOURCES:
      const newResources = action.payload.resources || [];
      const ROWS_PER_PAGE = 8;
      const existingIds = new Set(state.resources.map((r) => r.id));
      const uniqueNewResources = newResources.filter(
        (r) => !existingIds.has(r.id)
      );
      return {
        ...state,
        loading: false,
        error: false,
        resources:
          action.payload.pageNumber === 1
            ? newResources
            : [...state.resources, ...uniqueNewResources],
        hasMore: newResources.length === ROWS_PER_PAGE,
      };
    case SUCCESS_SHOW_RESOURCE:
      return {
        ...state,
        resourceSelected: action.payload.resource,
        msg: action.payload.msg,
        error: false,
        loading: false,
        showEditForm: true,
      };
    case SUCCESS_VIEW_RESOURCE:
      return {
        ...state,
        resourceSelected: action.payload.resource,
        msg: action.payload.msg,
        error: false,
        loading: false,
        showViewForm: true,
        showEditForm: false,
        showCreateForm: false,
      };
    case SUCCESS_STORE_RESOURCE:
      return {
        ...state,
        reload: true,
        msg: action.payload.msg,
        error: false,
        loading: false,
        showEditForm: false,
        showCreateForm: false,
      };
    case SUCCESS_UPDATE_RESOURCE:
      return {
        ...state,
        reload: true,
        msg: action.payload.msg,
        error: false,
        loading: false,
        showEditForm: false,
        showCreateForm: false,
      };
    case SUCCESS_DELETE_RESOURCE:
      return {
        ...state,
        resources: state.resources.filter(
          (resource: any) => resource.id !== Number(action.payload.resource_id)
        ),
        msg: action.payload.msg,
        error: false,
        loading: false,
        showEditForm: false,
        showCreateForm: false,
      };
    case SUCCESS_TOGGLE_FORM_EDIT_RESOURCES:
      return {
        ...state,
        showEditForm: !state.showEditForm,
      };
    case SUCCESS_TOGGLE_FORM_CREATE_RESOURCES:
      return {
        ...state,
        showCreateForm: !state.showCreateForm,
      };
    case SUCCESS_TOGGLE_FORM_VIEW_RESOURCES:
      return {
        ...state,
        showViewForm: !state.showViewForm,
      };
    case SUCCESS_FILTER_RESOURCES:
      return {
        ...state,
        resources: action.payload.resources,
        error: false,
        loading: false,
        reload: false,
      };
    case SUCCESS_ASSIGN_TAG_RESOURCE:
      return {
        ...state,
        resources: state.resources.map((resource: any) =>
          resource.id === action.payload.id
            ? { ...resource, tags: action.payload.tags.toString() }
            : resource
        ),
        error: false,
        loading: false,
        reload: false,
      };
    case SUCCESS_DELETE_TAG_RESOURCE:
      return {
        ...state,
        resources: state.resources.map((resource: any) => {
          if (resource.id === action.payload.id) {
            const currentTags =
              typeof resource.tags === "string" ? resource.tags.split(",") : [];
            const newTagsArray = currentTags.filter(
              (tagId: string) => Number(tagId) !== action.payload.tagId
            );
            const newTags =
              newTagsArray.length > 0 ? newTagsArray.join(",") : null;
            return { ...resource, tags: newTags };
          }
          return resource;
        }),
        error: false,
        loading: false,
        reload: false,
      };
    case SUCCESS_ASSIGN_HIGHLIGHT_RESOURCE:
      return {
        ...state,
        msg: action.payload.msg,
        error: false,
        loading: false,
        reload: true,
      };
    case SUCCESS_GET_HOME_RESOURCES:
      return {
        ...state,
        feedResources: action.payload.resources,
        msg: action.payload.msg,
        error: false,
        loading: false,
      };
    case SUCCESS_MASS_ASSIGNMENT_RESOURCES:
      return {
        ...state,
        msg: action.payload.msg,
        error: false,
        loading: false,
        reload: true,
      };
    case SUCCESS_UPDATE_ALIAS_RESOURCE:
      return {
        ...state,
        reload: true,
        loading: false,
        error: false,
        aliasUpdated: true,
      };
    case ERROR_GET_RESOURCES:
    case ERROR_SHOW_RESOURCE:
    case ERROR_VIEW_RESOURCE:
    case ERROR_STORE_RESOURCE:
    case ERROR_UPDATE_RESOURCE:
    case ERROR_DELETE_RESOURCE:
    case ERROR_FILTER_RESOURCES:
    case ERROR_ASSIGN_TAG_RESOURCE:
    case ERROR_DELETE_TAG_RESOURCE:
    case ERROR_ASSIGN_HIGHLIGHT_RESOURCE:
    case ERROR_GET_HOME_RESOURCES:
    case ERROR_UPDATE_ALIAS_RESOURCE:
    case ERROR_MASS_ASSIGNMENT_RESOURCES:
      return {
        ...state,
        reload: false,
        msg: action.payload,
        error: true,
        loading: false,
      };
    case START_SET_RESOURCE_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case START_CLEAR_RESOURCES:
      return {
        ...state,
        resources: [],
        page: 1,
        hasMore: true,
      };
    default:
      return state;
  }
}
